'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _take2 = require('lodash/take');

var _take3 = _interopRequireDefault(_take2);

var _reject2 = require('lodash/reject');

var _reject3 = _interopRequireDefault(_reject2);

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _head2 = require('lodash/head');

var _head3 = _interopRequireDefault(_head2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (dimensions, ids) {
  if ((0, _isEmpty3.default)(dimensions)) return;

  var symbolDimension = undefined;
  var id = (0, _get3.default)(ids, 'id');
  if (!(0, _isNil3.default)(id)) symbolDimension = (0, _find3.default)(dimensions, { id: id });

  if ((0, _isUndefined3.default)(symbolDimension)) {
    var isAreaOrTimeDimension = function isAreaOrTimeDimension(d) {
      return (0, _dotstatsuiteSdmxjs.isRefAreaDimension)(d) || (0, _dotstatsuiteSdmxjs.isTimePeriodDimension)(d);
    };
    var _dimensions1 = (0, _reject3.default)(dimensions, isAreaOrTimeDimension);
    var _dimensions2 = (0, _reject3.default)(dimensions, _dotstatsuiteSdmxjs.isRefAreaDimension);
    if ((0, _isEmpty3.default)(_dimensions1)) {
      symbolDimension = (0, _head3.default)((0, _isEmpty3.default)(_dimensions2) ? dimensions : _dimensions2);
    } else {
      symbolDimension = (0, _head3.default)(_dimensions1);
    }
  }

  var symbolDimensionId = (0, _get3.default)(symbolDimension, 'id');

  return {
    id: symbolDimensionId,
    serie: (0, _take3.default)(symbolDimension.values, 5)
  };
};